import { render, staticRenderFns } from "./comp_CheckoutSummaryCouponForm.vue?vue&type=template&id=974cc34c&"
import script from "./comp_CheckoutSummaryCouponForm.vue?vue&type=script&lang=js&"
export * from "./comp_CheckoutSummaryCouponForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VIcon})
